import { Button } from '@material-ui/core';
import { DateTime } from 'luxon';
import styled, { css } from 'styled-components';
import { CalendarDayInfo } from './calendar-day-info';

function isToday(day: Date): boolean {
    return DateTime.fromJSDate(day).hasSame(DateTime.now(), 'day');
}

function getVariantForDay($day: CalendarDayInfo): 'contained' | 'outlined' | 'text' {
    if ($day.isSelected || $day.isSelectedTo) {
        return 'contained';
    }
    return 'text';
}

function getColorForDay($day: CalendarDayInfo): 'default' | 'primary' {
    if ($day.isSelected || $day.isSelectedTo) {
        return 'primary';
    }
    return 'default';
}

function getFontWeightForDay({ $day }: CalendarDayButtonProps): string {
    return $day.isHovered ? '400' : '400';
}

function getFontColorForDay({ $day }: CalendarDayButtonProps): string | undefined {
    if (!$day.isCurrentMonth && !$day.isSelected && !$day.isSelectedTo) {
        return 'color: #8e8e8e;';
    }
    return undefined;
}

export interface CalendarDayButtonProps {
    $day: CalendarDayInfo;
}

export const CalendarDayButton = styled(Button).attrs<CalendarDayButtonProps>(props => ({
    color: getColorForDay(props.$day),
    variant: getVariantForDay(props.$day),
}))`
    min-width: 0px;
    height: 48px;
    width: 48px;
    padding: 0;
    font-family: ${({ theme }) => theme.typography.body1.fontFamily};
    ${({ $day, theme }) =>
        isToday($day.date) &&
        css`
            border: 1px solid ${theme.palette.grey[300]};
        `}
    > span {
        font-weight: ${getFontWeightForDay};
        ${getFontColorForDay}
    }
    &:focus-visible {
        /* outline: 2px solid ${({ theme }) => theme.palette.primary.main}; */
        font-weight: 700;
        box-shadow: 0 2px 10px ${({ theme }) => theme.palette.grey[400]};
    }
`;
CalendarDayButton.displayName = 'CalendarDayButton';
